import React, { useEffect, useRef, useState } from 'react';

export default function CopyButton({ text, className = 'btn btn-outline btn-sm' }) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const handleCopy = async () => {
    try {
      // navigator.clipboard only exists in a secure context (HTTPS or localhost) — fall
      // back to the legacy execCommand approach so copying still works when that API
      // isn't available (e.g. the site served over plain HTTP).
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      setCopied(true);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(false), 1000);
    } catch {
      // clipboard access denied or unavailable; nothing to recover from here
    }
  };

  return (
    <button type="button" className={className} onClick={handleCopy}>
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
}
